window.timber = window.timber || {};

timber.init = function () {
  timber.equalHeights();
  timber.magnificPop();
  timber.slick();
  timber.instagram();
  
  
};



timber.equalHeights = function () {
  $(".match").matchHeight();
  $(".viewedProds").matchHeight();
  $(".match-js").matchHeight();
  $(".h-match").matchHeight();
  $(".customer-page .form-vertical").matchHeight();
  $(".fMatch").matchHeight();
  $(".featbuttons").matchHeight();
}

timber.magnificPop = function () {
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false
  });
  
  $('.newsletterPop').magnificPopup ({
    type: 'inline',
    preloader: false
  });
  
  $('#ProductPhoto').magnificPopup({
    delegate: 'a',
    type: 'image',
    closeOnContentClick: true,
    gallery:{
      enabled:true
    }
  });

  $('.popup-gallery').each(function() { // the containers for all your galleries
    $(this).magnificPopup({
      delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		}
    });
  });
}

timber.slick = function () {
  $('.homeslider').slick({
    autoplay: false,
    speed: 60*100,
    dots: true,
    arrows: true
  });
}



timber.instagram = function () {
  
  if ( $( "#instafeed" ).length ) {
    
    
    

    var userFeed = new Instafeed({
      get: 'user',
      userId: 1425432027,
      accessToken: '1425432027.5ea0515.b1fdbd3557b6459781e1bd0b88a34d86',
      template: '<a target="_blank" href="{{link}}" rel="ig" title="{{caption}}"><img class="instagram-image" src="{{image}}" /></a>'
    });
    userFeed.run(); 
  }
}

// Initialize Timber's JS on docready
$(timber.init);

$(window).load(function() {
  $(".product--textArea .h6").matchHeight();
});

$(document).ready(function(){
  $('.slick__product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slick__navigation'
  });

  $('.slick__navigation').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slick__product',
    dots: false,
    adaptiveHeight: true,
    focusOnSelect: true
  });
});